
const NotFound = () => {

    return(
        <div>
            <h1>Not found page</h1>
        </div>
    )
}
export default NotFound;